"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInspectArgs = exports.getAppendArgs = exports.getCreateArgs = exports.getBuilderName = exports.getInputs = exports.builderNodeEnvPrefix = void 0;
const uuid = __importStar(require("uuid"));
const core = __importStar(require("@actions/core"));
const docker_1 = require("@docker/actions-toolkit/lib/docker/docker");
const util_1 = require("@docker/actions-toolkit/lib/util");
exports.builderNodeEnvPrefix = 'BUILDER_NODE';
function getInputs() {
    return __awaiter(this, void 0, void 0, function* () {
        return {
            version: core.getInput('version'),
            name: yield getBuilderName(core.getInput('driver') || 'docker-container'),
            driver: core.getInput('driver') || 'docker-container',
            driverOpts: util_1.Util.getInputList('driver-opts', { ignoreComma: true, quote: false }),
            buildkitdFlags: core.getInput('buildkitd-flags') || '--allow-insecure-entitlement security.insecure --allow-insecure-entitlement network.host',
            platforms: util_1.Util.getInputList('platforms'),
            install: core.getBooleanInput('install'),
            use: core.getBooleanInput('use'),
            endpoint: core.getInput('endpoint'),
            config: core.getInput('config'),
            configInline: core.getInput('config-inline'),
            append: core.getInput('append'),
            cleanup: core.getBooleanInput('cleanup')
        };
    });
}
exports.getInputs = getInputs;
function getBuilderName(driver) {
    return __awaiter(this, void 0, void 0, function* () {
        return driver == 'docker' ? yield docker_1.Docker.context() : `builder-${uuid.v4()}`;
    });
}
exports.getBuilderName = getBuilderName;
function getCreateArgs(inputs, toolkit) {
    return __awaiter(this, void 0, void 0, function* () {
        const args = ['create', '--name', inputs.name, '--driver', inputs.driver];
        if (yield toolkit.buildx.versionSatisfies('>=0.3.0')) {
            yield util_1.Util.asyncForEach(inputs.driverOpts, (driverOpt) => __awaiter(this, void 0, void 0, function* () {
                args.push('--driver-opt', driverOpt);
            }));
            if (inputs.driver != 'remote' && inputs.buildkitdFlags) {
                args.push('--buildkitd-flags', inputs.buildkitdFlags);
            }
        }
        if (inputs.platforms.length > 0) {
            args.push('--platform', inputs.platforms.join(','));
        }
        if (inputs.use) {
            args.push('--use');
        }
        if (inputs.driver != 'remote') {
            if (inputs.config) {
                args.push('--config', toolkit.buildkit.config.resolveFromFile(inputs.config));
            }
            else if (inputs.configInline) {
                args.push('--config', toolkit.buildkit.config.resolveFromString(inputs.configInline));
            }
        }
        if (inputs.endpoint) {
            args.push(inputs.endpoint);
        }
        return args;
    });
}
exports.getCreateArgs = getCreateArgs;
function getAppendArgs(inputs, node, toolkit) {
    return __awaiter(this, void 0, void 0, function* () {
        const args = ['create', '--name', inputs.name, '--append'];
        if (node.name) {
            args.push('--node', node.name);
        }
        else if (inputs.driver == 'kubernetes' && (yield toolkit.buildx.versionSatisfies('<0.11.0'))) {
            args.push('--node', `node-${uuid.v4()}`);
        }
        if (node['driver-opts'] && (yield toolkit.buildx.versionSatisfies('>=0.3.0'))) {
            yield util_1.Util.asyncForEach(node['driver-opts'], (driverOpt) => __awaiter(this, void 0, void 0, function* () {
                args.push('--driver-opt', driverOpt);
            }));
            if (inputs.driver != 'remote' && node['buildkitd-flags']) {
                args.push('--buildkitd-flags', node['buildkitd-flags']);
            }
        }
        if (node.platforms) {
            args.push('--platform', node.platforms);
        }
        if (node.endpoint) {
            args.push(node.endpoint);
        }
        return args;
    });
}
exports.getAppendArgs = getAppendArgs;
function getInspectArgs(inputs, toolkit) {
    return __awaiter(this, void 0, void 0, function* () {
        const args = ['inspect', '--bootstrap'];
        if (yield toolkit.buildx.versionSatisfies('>=0.4.0')) {
            args.push('--builder', inputs.name);
        }
        return args;
    });
}
exports.getInspectArgs = getInspectArgs;
